//import "@babel/polyfill";
class dataServices {
  constructor() {
    this.baseAddress = "/modService/api/";
  }

//  const getSPListItems = (siteUrl, listName, viewName) =>{
//     try {
//       let baseAddress = "/modService/api/";
//       let reqItems = {
//         webUrl: siteUrl,
//         listName: listName,
//         viewName: viewName,
//         showAttach: "true",
//         showLookupChild: true,
//       };
//       listName = encodeURIComponent(listName);
//       viewName = encodeURIComponent(viewName);
//       // let address = `${this.baseAddress}Items`;
//       let address = `${baseAddress}Items`
//       // return axios.post(address, reqItems);

//       let requestOptions = {
//         method: "post",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(reqItems),
//       };
//       let resualt = fetch(address, requestOptions).then((response) =>
//       {
//         debugger;
//       setResult( response.json());
//       }
//       );
//     } catch (err) {
//       console.log("error at fetch 2: l" + err);
//     }
//   }
  
  getSPListItems(siteUrl, listName, viewName) {
    let reqItems = {
      webUrl: siteUrl,
      listName: listName,
      viewName: viewName,
      showAttach: "true",
      showLookupChild: true,
    };
    listName = encodeURIComponent(listName);
    viewName = encodeURIComponent(viewName);
    let address = `${this.baseAddress}Items`;
    return axios.post(address, reqItems);
  }

  getSPListItemsForce(siteUrl, listName, viewName) {
    let reqItems = {
      webUrl: siteUrl,
      listName: listName,
      viewName: viewName,
      showAttach: "true",
      showLookupChild: true,
    };
    listName = encodeURIComponent(listName);
    viewName = encodeURIComponent(viewName);
    let address = `${this.baseAddress}ItemsForce`;
    return axios.post(address, reqItems);
  }

  setItems(data) {
    let address = `${this.baseAddress}NewItem`;
    return axios.post(address, data);
  }
}

export default new dataServices();
